import { Interp, css } from '../lib/render.jsx';
import { Kruis } from './Iconen.jsx';
import { iconStroke } from '../lib/icons.js';

/**
 * De schil om een venster: kader, titelbalk, kruisje, en de greep om te slepen.
 *
 * Elk programmaatje op het bureaublad had die schil overgetypt: een div met
 * `data-venster`, een div met het kader, een titelbalk met vier pointerhandlers en
 * een kruisje. Vier keer hetzelfde, en elke keer dat er iets aan de laag verandert
 * moet je ze allemaal langs. Nu staat het hier één keer.
 *
 * De stijlen komen uit `vensterVals` in [logic/venster.js]; deze schil weet er niets
 * van en zet alleen neer wat hij meekrijgt. Wat erin staat is `children`, en dat
 * krijgt zijn eigen inhoudstijl van het venster zelf: het kader is een flexkolom, dus
 * de inhoud regelt zijn eigen padding en of hij scrollt.
 *
 * De vier handlers op de balk en niet op het hele venster: slepen doe je aan de
 * titelbalk. Naar voren halen wél op het hele venster, in de opvangfase, zodat de
 * klik daarna gewoon zijn eigen werk doet. Zie sectie 14 van CLAUDE.md voor de regel
 * dat een balk met knoppen erin de sleep moet overslaan.
 */
export default function Venster({ v, venster, titel, naast, onSluit, extra, children }) {
  return (
    <div data-venster={venster?.naam} onPointerDownCapture={venster?.naarVoren} style={css(venster?.staStyle)}>
      <div style={css(venster?.kaderStyle)}>
        <div
          onPointerDown={venster?.sleepAan} onPointerMove={venster?.sleep}
          onPointerUp={venster?.sleepUit} onPointerCancel={venster?.sleepUit}
          style={css(venster?.balkStyle)}
        >
          <div style={css(venster?.titelStyle)}><Interp v={titel} /></div>
          {/* `naast` is wat er bij de titel hoort en geen knop is: de klok van de
              Krabbellijn bijvoorbeeld. Die staat links van het knoppensetje, want
              tussen de vensterknoppen zou hij als knop gaan lezen. */}
          {naast}
          {/* Eén setje rechts: wegklappen, dan wat dit venster zelf nog aanbiedt
              (groot maken, geluid), dan sluiten. In een eigen groepje, zodat het gat
              van de balk alleen tussen de titel en het setje valt en niet ook nog
              tussen de knoppen. Zie vensterKnopRijStyle in logic/venster.js. */}
          <div style={css(venster?.knopRijStyle)}>
            {/* Wegklappen: het venster uit beeld, het balkje blijft in de taakbalk
                staan. Een streepje, zoals in elke taakbalk. Het kruisje doet hem echt
                dicht en haalt dat balkje weg. Zie vensterLijst in logic/venster.js. */}
            {venster?.kanWeg ? (
              <button onClick={venster?.weg} title="Wegklappen" aria-label="Wegklappen" style={css(venster?.knopStyle)}>
                {/* Dezelfde lijndikte als het kruisje ernaast (iconStroke). Op 3.3 was het
                    streepje een derde dikker dan het kruisje. */}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={iconStroke(20)} strokeLinecap="round">
                  <path d="M5 18h14" />
                </svg>
              </button>
            ) : null}
            {extra}
            <button onClick={onSluit || venster?.sluit} title="Sluiten" aria-label="Sluiten" style={css(venster?.knopStyle)}>
              <Kruis maat={20} />
            </button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
